/**
 * Convert a number to an ordinal string (1st, 2nd, 3rd, etc.)
 */
export function toOrdinal(n: number): string {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

/**
 * Add unit string (e.g., "1 pope", "2 popes")
 */
export function addUnit(count: number, unit: string): string {
  if (count === 1) {
    return `1 ${unit}`;
  }
  return `${count} ${unit}s`;
}

/**
 * Calculate age in months from birth year and month
 */
export function calculateAgeMonths(birthYear: number, birthMonth: number): number {
  const now = new Date();
  const currentTotalMonths = now.getFullYear() * 12 + now.getMonth(); // getMonth() returns 0-11
  const birthTotalMonths = birthYear * 12 + (birthMonth - 1); // birthMonth is 1-12, convert to 0-11
  return currentTotalMonths - birthTotalMonths;
}

/**
 * Get birth year and month from age in months
 */
export function getBirthFromAge(ageMonths: number): { year: number; month: number } {
  const now = new Date();
  const currentTotalMonths = now.getFullYear() * 12 + now.getMonth(); // getMonth() returns 0-11
  const birthTotalMonths = currentTotalMonths - ageMonths;
  
  const year = Math.floor(birthTotalMonths / 12);
  const monthIndex = birthTotalMonths % 12; // This gives us 0-11
  const month = monthIndex + 1; // Convert to 1-12 range
  
  return { year, month };
}

/**
 * Validate email format
 */
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Format age from years and months
 */
export function formatAge(years: number, months: number): string {
  let age = `${years} year${years === 1 ? '' : 's'}`;
  if (months > 0) {
    age += ` ${months} month${months === 1 ? '' : 's'}`;
  }
  return age;
}
